export default {
  header: {
    index: '首頁',
    hotel: '酒店',
    ticket: '門票',
    tour: '線路',
    user: '用戶',
    yl: '郵輪',
    gntp: '套票'
  },
  tplist: {
    sstp: '搜尋套票',
    zdzh: '找到最適合您的旅行套裝',
    qsrt: '請輸入套票名稱搜尋',
    ydrq: '預訂日期',
    xzqy: '選擇區域',
    ss: '搜尋',
    jxtp: '精選套票',
    fxzs: '發掘最受歡迎的旅行體驗',
    ckxq: '查看詳情',
    rmmd: '熱門目的地',
    sscf: '隨時出發',
    q: '起',
    ljyd: '立即預訂',
    zwtp: '暫無套票數據',
    zsmy: '暫時沒有找到符合條件的套票，請嘗試調整搜尋條件',
    cxjz: '重新載入',
    hk: '香港',
    am: '澳門',
    dl: '大陸',
    tw: '台灣',
    hw: '海外',
    loading: '載入中...',
    loadFailed: '圖片載入失敗'
  },
  tpdetail: {
    xzfj: '選擇附加產品',
    tpne: '套票內容與說明',
    zkqb: '展開全部',
    qb: '全部',
    fybh: '費用包含',
    dqrq: '當前日期不可預訂',
    grqz: '該日期暫無可預訂的產品',
    xzrq: '選擇日期',
    ytdg: '一同訂購更多體驗，包括觀光桌、門票、交通接駁等！',
    txgd: '挑選更多遊樂體驗',
    qcsy: '清除所有',
    crzw: '此日暫無價格',
    zwjg: '暫無價格',
    tpje: '套票金額補差',
    jd: '酒店',
    bkd: '不可訂',
    ddyd: '單獨預訂價格',
    xj: '星級',
    fx: '房型',
    jdss: '酒店設施',
    rssx: '人數上限',
    zd: '最多',
    r: '人',
    d: '大',
    x: '小',
    mp: '門票',
    ydxz: '預訂須知',
    cpxq: '產品詳情',
    cq: '餐券',
    bc: '包車',
    dy: '行程',
    qtcp: '其他產品',
    fhcp: '返回產品列表',
    zzjs: '正在計算價格...',
    zzjz: '正在載入價格，請稍候...',
    gcpw: '個產品未完成選擇',
    hy: '還有',
    qx: '取消',
    jdzs: '酒店住宿',
    jdmc: '酒店名稱',
    fxmc: '房型名稱',
    h: '含',
    fzc: '份早餐',
    bhz: '不含早',
    j: '間',
    w: '晚',
    syrq: '使用日期',
    sl: '數量',
    fjcp: '附加產品',
    hjzj: '合計總金額',
    xyb: '下一步 立即預訂',
    tpsl: '套票數量',
    gqsh: '正在計算價格，請稍候...',
    tpyd: '套票預訂須知',
    zdl: '知道了',
    cqmp: '餐券/門票',
    fxtc: '非系統產品',
    tpxq: '套票詳情',
    gxx: '個選項',
    qf: '份',
    qd: '確定',
    jzz: '載入中...',
    qdsc: '確定要刪除這個附加產品嗎？',
    qdqc: '確定要清除所有附加產品嗎？',
    crzj: '此日暫無價格',
    zj: '暫無價格',
    crzjqxtrq: '此日暫無價格，請選擇其他日期',
    tpnrzjqxtrq: '套票內容暫無價格，請選擇其他日期',
    crzjqxtrq2: '此日暫無價格，請選擇其他日期',
    tpnrzjqxtrq2: '套票內容暫無價格，請選擇其他日期',
    tpnrzjwbyd: '套票內容暫無價格，無法預訂',
    zjqkzql: '暫無價格，數量已自動清零',
    crzjqkzql: '此日暫無價格請重新選擇',
    z: '張',
    // 早餐信息翻譯
    noBreakfast: '不含早',
    breakfast1: '含1份早',
    breakfast2: '含2份早',
    breakfastCount: '含{count}份早',

    // 錯誤提示信息
    completeAddOnSettings: '請完成附加產品設定或點擊「清除所有」移除未完成的附加產品',
    hotelNotAvailable: '酒店部分不可訂',
    ticketNotAvailable: '門票部分不可訂',
    packageNotAvailable: '套票當前日期不可訂',
    bookingConditionsNotMet: '預訂條件不滿足，請檢查選擇的內容',
    bookingConditionsNotMetNoJump: '預訂條件不滿足，無法跳轉',
    productUnavailableForDate: '此日產品暫不可訂',
    productUnavailableForDateMessage: '此日產品暫不可訂，請選擇其他日期'
  },
  tporder: {
    tpne: '套票名稱',
    zkqb: '預訂數量',
    fybh: '使用日期',
    dqrq: '價格詳情',
    grqz: '套票數量',
    xzrq: '收起套票包含內容',
    wlbh: '查看套票包含內容',
    txgd: '酒店住宿',
    qcsy: '門票景點',
    crzw: '數量',
    zwjg: '其他產品',
    tpje: '人數補差價格',
    jd: '收起附加產品',
    ckfj: '查看附加產品',
    ddyd: '附加產品',
    zxzf: '線上支付',
    fj: '新增遊客',
    jdss: '遊客',
    rssx: '姓氏',
    zd: '請輸入姓氏',
    r: '張',
    d: '名字',
    x: '請輸入名字',
    mp: '性別',
    bkd: '請選擇性別',
    ydxz: '預定須知',
    cpxq: '產品詳情',
    z: '我們會傳達您的要求，但不保證能滿足',
    cq: '附加資訊',
    bc: '預訂須知',
    qtcp: '此產品需要二次確認！',
    fhcp: '暫無詳細資訊',
    qf: '關閉',
    zzjs: '至少需要保留1名遊客',
    xj: '暫無預訂須知資訊',
    zzjz: '暫無產品詳情資訊',
    tpmc: '套票名稱',
    ydsl: '預訂數量',
    syrq: '使用日期',
    jgxq: '價格詳情',
    tpsl: '套票數量',
    jdzs: '酒店住宿',
    mpjd: '門票景點',
    qtcp2: '其他產品',
    rscb: '人數補差價格',
    fjcp: '附加產品',
    wfjcp: '暫無附加產品',
    zxzf2: '線上支付',
    xzyk: '新增遊客',
    yk: '遊客',
    xs: '姓氏',
    qsrxs: '請輸入姓氏',
    mz: '名字',
    qsrmz: '請輸入名字',
    xb: '性別',
    qxzxb: '請選擇性別',
    n: '男',
    nv: '女',
    bzxx: '備註資訊',
    fhcp2: '返回產品列表',
    gb: '關閉',
    zdyk: '至少需要保留1名遊客',
    zwydxz: '暫無預訂須知資訊',
    zwcpxq: '暫無產品詳情資訊',
    tpxq: '套票詳情',
    ydxz2: '預訂須知',
    cpxq2: '產品詳情',
    hj: '合計'
  },
  gntp: {
    sycp: '所有產品',
    mpjd: '門票景點',
    jdtp: '酒店套票',
    ddms: '當地美食',
    ddhqc: '當地好去處',
    splb: '商品類別',
    dq: '地區',
    gjz: '關鍵字',
    ss: '搜索',
    hpl: '好評率',
    ydts: '預定提示',
    xzcp: '選擇產品',
    ecqr: '產品由合作夥伴提供，預定後需二次確認。',
    jjqg: '立即搶購',
    cpjs: '產品介紹',
    jtxl: '交通線路',
    cpfl: '产品分类',
    mdd: '目的地'
  },
  util: {
    Agreement: '分銷申請協議',
    ljcz: '立即重置',
    yzm: '驗證碼',
    fsyzm: '發送驗證碼',
    qsryzm: '請輸入驗證碼',
    yyzh: '已有賬號，登錄',
    ljzc: '立即註冊',
    jrwm: '加入HUAYI',
    zdj: '最低價',
    q: '起',
    jrck: '進入查看',
    cfd: '出發地',
    cfrq: '出發日期',
    xcts: '行程天數',
    mddgjz: '目的地/關鍵字',
    mdd: '目的地',
    rzrq: '入住日期',
    w: '晚',
    ldrq: '離店日期',
    fjzks: '房間&住客數',
    fjs: '房間數',
    crs: '成人數',
    ets: '兒童數',
    qd: '確定',
    j: '間',
    cr: '成人',
    xt: '小童',
    ss: '搜索',
    jdxj: '酒店星級',
    ywrq: '遊玩日期',
    z: '週',
    pjmwbhsj: '平均每晚不含稅價',
    drysw: '當日已售完',
    ck: '查看',
    dg: '訂購',
    dz: '地址',
    bz: '幣種',
    zhyb: '最後一步',
    ydxq: '預訂詳情',
    yxjd: '已選酒店',
    yxcp: '已選產品',
    llwm: '聯絡我們',
    bqsy: '版權所有',
    yysjyw: '營業時間以外請致電',
    yysj: '營業時間',
    rjkfdh: '日間客服電話',
    khfwzy: '客戶服務支援',
    lxwm: '聯繫我們',
    mee: 'MEE美意 APP',
    gywm: '關於我們',
    zzjzgd: '正在加載更多中',
    wsydx: '我是有底線的',
    htgdsfzhdr: '或通過第三方帳戶登入',
    wjmm: '忘記密碼',
    myzh: '沒有賬號?立即註冊',
    ljdl: '立即登錄',
    ystk: '隱私條款',
    tkxz: '條款及細則',
    khdl: '客戶登錄',
    thdl: '同行登錄',
    yhm: '用戶名',
    yhmdesc: '請輸入用戶名',
    mm: '密碼',
    mmdesc: '請輸入密碼',
    ty: '同意',
    qxtytkxz: '請先同意條款及細則',
    wddd: '我的訂單',
    tcdl: '退出登錄',
    drhqhyzg: '登入以獲取會員價格',
    drhzc: '登入或註冊',
    ydjc: '預定檢測',
    qxdl: '請先登錄',
    gxn: '恭喜您，您已選擇最優價格產品',
    hyh: '很遺憾，當前產品暫不可訂'
  },
  index: {
    slogan: '千里之行 始於華逸',
    jdyd: '酒店預訂',
    djtp: '度假套票',
    mscj: '美食餐券',
    jdmp: '景點門票',
    gty: '跟團游',
    hwsdy: '戶外深度游',
    hwly: '戶外露營',
    wqdj: '溫泉度假',
    appTitle: '旅行 ． 從此簡單',
    appDesc: '隨時隨地，只需幾秒，即可輕鬆預訂機票、酒店、火車票及租車。',
    hzhb: '合作夥伴',
    hzhbdesc: 'HUAYI TRAVEL 攜手各領域合作夥伴，為您提供最完善的旅遊體驗',
    jdtj: '酒店推介',
    zwcp: '暫無產品',
    cjtj: '餐券推介',
    ddwl: '當地玩樂推介',
    rmxc: '熱門行程',
    rm: '熱門',
    gat: '港澳台',
    gn: '國內',
    dny: '東南亞',
    az: '澳洲',
    oz: '歐洲',
    tp: '套票',
    xg: '香港',
    am: '澳門',
    zyx: '自由行',
    xl: '線路',
    rb: '日本',
    jd: '酒店'
  },
  cruise: {
    yl: '游輪',
    bz: '種類',
    bh: '編號',
    mc: '名稱',
    xc: '行程',
    cfrq: '出發日期',
    ljbl: '立即辦理'
  },
  hotel: {
    bhs: '本優恵價未含發票等稅費（如有）',
    tf: '入住和退房時間均為酒店當地時間.',
    djrl: '低價日曆(當日最低價)',
    night: '晚',
    Sun: '日',
    Mon: '一',
    Tus: '二',
    Wes: '三',
    Thur: '四',
    Fri: '五',
    Sat: '六',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    five: '五',
    six: '六',
    seven: '日',
    jjd: '家酒店',
    gzd: '共找到',
    yfdsjbdpf: '因酒店售價波動頻繁，實際應付金額以訂單成立後為準',
    pjmwhsj: '平均每晚含稅價',
    exj: '二星及以下/經濟',
    snxj: '三星/舒適',
    sxj: '四星/高級',
    wxj: '五星/豪華',
    xj: '星級',
    ljqr: '立即確認',
    tp: '套票',
    hzc: '含早餐',
    rmsx: '熱門篩選',
    xsdt: '顯示地圖',
    ss: '搜索',
    et: '兒童',
    cr: '成人',
    qd: '確定',
    ets: '兒童數',
    crs: '成人數',
    fjs: '房間數',
    fjsjrs: '房間數及人數',
    w: '晚',
    ldrq: '離店日期',
    rzrq: '入住日期',
    mdd: '目的地/關鍵字',
    zwcxdfx: '暫無查詢到房型',
    zyzx: '重要資訊',
    jqld: '景區亮點',
    jdjs: '酒店介紹',
    z: '張',
    hj: '合計',
    wzc: '位早餐',
    h: '含',
    bhz: '不含早',
    gxsjh: '個銷售計劃',
    zsew: '展示額外',
    yc: '隱藏',
    yd: '預定',
    bhsjfwf: '不含稅及服務費',
    xsyh: '限時優惠',
    bnqx: '不能取消',
    gatzx: '港澳台專享',
    ydts: '預定提示',
    pjmfmwjg: '平均每房每晚價格',
    xgzc: '相關政策',
    mc: '名稱',
    zxzf: '在線支付',
    j: '間',
    jgxq: '價格詳情',
    fh: '返回',
    tjcddjbsnyydbty: '提交此訂單即表示您已閱讀並同意 huayitraveltd.com 之使用細則與私隱條款。',
    xybzhqr: '下一步：最後確認',
    czsjjzdnl: '此住宿將盡最大努力，但不能保證可滿足所有要求。',
    xt: '（選填）',
    tsyq: '特殊要求',
    dl: '大陸86',
    am: '澳門853',
    xg: '香港852',
    jyykhfw: '僅用於客戶服務',
    qsrzqdhhm: '請輸入正確電話號碼',
    dhhm: '電話號碼',
    yyjsqryj: '用於接收確認郵件',
    qsrzqyxdz: '請輸入正確郵箱地址',
    qsryxdz: '請輸入郵箱地址',
    dy: '電郵',
    gajdqtyw: '港澳海外酒店請填寫英文或拼音',
    mzdesc: '請輸入名字',
    mz: '名字',
    xsdesc: '請輸入姓氏',
    xs: '姓氏',
    xzzk: '新增住客(可選)',
    fj: '房間',
    rkzldesc: '住客姓名必須與登記入住時使用之有效證件完全一致。',
    zkzl: '住客資料',
    gmsl: '購買數量',
    dj: '單價',
    fjcp: '附加產品',
    tyd: '天預定',
    xtq: '需提前',
    rzts: '入住天數',
    zao: '早',
    zcsl: '早餐數量',
    etnl: '兒童年齡',
    mfjrzet: '每房間入住兒童',
    mfjrzcr: '每房間入住成人',
    mfjzdrz: '每房間最大入住',
    fx: '房型',
    xsjh: '銷售計劃',
    dz: '地址',
    qsrdhhm: '請輸入電話號碼',
    ts: '提示',
    ROO: '每房',
    bz: '幣種'
  },
  tour: {
    qrww: '確定無誤',
    qx: '取 消',
    tkzc: '條款政策',
    zj: '證件',
    csrq: '出生日期',
    xb: '性別',
    yx: '郵箱',
    dh: '電話',
    xm: '姓名',
    bc: '補差',
    ye: '嬰兒',
    etbzc: '兒童不佔床',
    et: '兒童',
    cr: '成人',
    cf: '出發',
    fc: '返程',
    qecqryxxx: '請二次確認以下信息',
    xcjs: '行程介紹',
    fybh: '費用包含',
    zfxm: '自費項目',
    tbtx: '特別提醒',
    fyxz: '費用細則',
    xzxc: '下載行程',
    wqts: '溫馨提示',
    bjbz: '報價幣種',
    xcwd: '行程文檔',
    jhd: '集合地',
    rqxz: '人群限制',
    hyly: '華逸旅遊',
    qglm: '全國聯盟',
    tj: '推薦+',
    jrck: '進入查看',
    ljyd: '立即預定',
    cfrq: '出發日期',
    xt: '小童',
    zc: '占床',
    bzc: '不佔床',
    ze: '總額',
    xtzc: '小童占床',
    xtbzc: '小童不佔床',
    ksyd: '開始預訂',
    ywzt: '遊玩主題',
    zyx: '自由行',
    gty: '跟團游',
    bx: '不限',
    lx: '類型',
    mdd: '目的地',
    ss: '搜索',
    qsrmddjdgjz: '請輸入目的地、景點、關鍵詞、或參考團號',
    cfd: '出發地',
    drbc: '單人補差',
    sfz: '身份證',
    hz: '護照',
    gahxz: '港澳回鄉證',
    tbz: '台胞證',
    qt: '其他',
    ts: '天數',
    hcrq: '回程日期',
    ykzl: '遊客資料',
    xs: '姓氏',
    qsrxs: '請輸入姓氏',
    mz: '名字',
    qsrmz: '請輸入名字',
    qsrdh: '請輸入電話',
    qsryx: '請輸入郵箱',
    qxzxb: '請選擇性別',
    qsrcsrq: '請輸入出生日期',
    qsrzj: '請輸入證件',
    qxz: '請選擇',
    dy: '電郵',
    qsryxdz: '請輸入郵箱地址',
    qsrzqyx: '請輸入正確郵箱地址',
    yyjsqryj: '用於接收確認郵件',
    dhhm: '電話號碼',
    qsrdhhm: '請輸入電話號碼',
    qsrzqdhhm: '請輸入正確電話號碼',
    jyykhfw: '僅用於客戶服務',
    xg: '香港852',
    am: '澳門853',
    dl: '大陸86',
    tsyq: '特殊要求',
    xuantian: '（選填）',
    tjcddbsnyydbty: '提交此訂單即表示您已閱讀並同意 huayitraveltd.com 之使用細則與私隱條款。',
    xybzhqr: '下一步：最後確認',
    fh: '返回',
    jgxq: '價格詳情',
    hj: '合計',
    zxzf: '在線支付',
    xxzf: '線下支付'
  },
  ticket: {
    hj: '合計',
    z: '張',
    zdj: '最低價',
    xzsl: '選擇數量',
    xz: '選擇',
    qxxz: '取消選擇',
    q: '起',
    ljgm: '立即購買',
    qxzcp: '請選擇產品',
    dj: '數量/單價',
    cp: '產品',
    g: '個',
    xqjs: '詳情介紹',
    ydts: '預定提示',
    zwcp: '暫無產品',
    xzfa: '選擇方案',
    xzrq: '選擇日期',
    hdfl: '活動分類',
    mpjd: '門票景點',
    mscj: '美食餐券',
    mbqy: '目標區域',
    gzd: '共找到',
    gjz: '關鍵字',
    jgfw: '價格範圍',
    qd: '確定',
    ksqr: '快速確認',
    gzsjn: '工作時間內，3小時內確認訂單。',
    ydrq: '預定日期',
    dz: '地址',
    xj: '小計',
    fhxg: '返回修改',
    ykxx: '遊客信息',
    yk: '遊客',
    xm: '姓名',
    qsrxm: '請輸入正確姓名',
    sj: '手機',
    qsrsj: '請輸入手機',
    ywm: '英文名',
    qsrywm: '請輸入英文名',
    qsryx: '請輸入郵箱',
    yx: '郵箱',
    zj: '證件',
    qsrzj: '請輸入證件',
    qsremail: '請輸入email',
    lldh: '聯絡電話',
    qsrlxdh: '請輸入聯絡電話',
    xg: '香港852',
    am: '澳門853',
    dl: '大陸86',
    bz: '備註',
    cddyydty: '提交此訂單即表示您已閱讀並同意 huayitraveltd.com 之使用細則與私隱條款。',
    xyb: '下一步：最後確認',
    pjyjscbtbg: '票卷一經售出不退不改。請務必核實信息後再提交。',
    ydtx: '預定提醒',
    zwbj: '暫無報價',
    djrl: '低價日曆',
    jgrl: '價格日曆'
  },
  specialEvent: {
    dh: '電話',
    cz: '傳真',
    kfsj: '開放時間',
    bz: '備註',
    sf: '收費',
    hdyf: '活動月份',
    dz: '地址',
    gjd: '個景點',
    macau: {
      am: '澳門',
      tsamszw: '探索澳門食住玩好去處',
      myswt: '民以食為天',
      myswtdesc: '想像當地人一樣尋訪地道美食？記得別錯過這些最受觀迎的澳門菜式及美食熱點。',
      jwzbh: '今晚住邊好',
      jwzbhdesc: '發掘澳門的最受歡迎住宿地點，以及其他旅客的推薦及特別酒店優惠。',
      ck: '查看',
      wlhqc: '玩樂好去處',
      wlhqcdesc: '想知澳門有什麼推薦活動？由不容錯過的景色，到當地人熱愛的聚腳地，我們能為您提供一切所需的最新資訊。',
      ddhd: '當地活動',
      ddhddesc: '查看本地當月熱門活動。',
      hdrq: '活動日期'
    },
    package: {
      zs: '住宿',
      mp: '門票'
    },
    oloq: {
      ozxhtdesc: '8條歐洲旅遊路線，每週循環，暢遊22個國家75座城市！歐洲當地參團，隨上隨下，全年保證出發！',
      ozxht: '歐來歐去循環式旅行團',
      oloqtdesc: '2005年始發，至今從不間斷，每年超過200,000人次參加！',
      oloqt: '歐來歐去循環式歐洲旅行團路線圖'
    },
    chimelong: {
      gzcl: '廣州長隆',
      zhcl: '珠海長隆',
      jd: '當季熱銷·酒店',
      mp: '當季熱銷·門票'
    },
    disney: {
      ljqwyd: '立即前往預定',
      hxdesc: '乘坐極速礦車，飛越灰熊山谷，在軌道縱橫交錯的礦洞內穿梭飛馳。礦車會帶你來回穿梭整個山谷，享受從山頂倒行急墜的快感，暢遊傳說中的尋金小鎮。',
      hx: '灰熊山極速礦車',
      szdesc: '獅子王辛巴、丁滿和彭彭跳出大銀幕，成為大型歌舞劇的主角，配合連串精彩的雜技和火舞表演，帶你體驗叢林的樂趣！',
      sz: '獅子王慶典',
      mfswdesc: '「迪士尼魔法書房」揉合迪士尼經典與新一代故事在華麗大舞台上精彩上演，呈獻數不盡的Happily Ever After感動時刻！',
      mfsw: '迪士尼魔法書房',
      tjqxDesc: '超級英雄，震撼登陸！踏入「史達工業」的未來科技世界，見證最新的科技鉅獻，更可戴上「史達前瞻智能眼鏡」，與「鐵甲奇俠」飛越香港上空，並一同對抗邪惡勢力「九頭蛇」！',
      tjqx: '「鐵甲奇俠飛行之旅」 ─ 由友邦呈獻',
      hgndesc: '一起來坐上經典的旋轉木馬，化身成迪士尼動畫《仙履奇緣》中的王子和公主，隨著悠揚的音樂旋轉、跳動。躍上華麗的旋轉木馬，在色彩繽紛的背景和悠揚的音樂中飛躍奔馳。',
      hgn: '灰姑娘旋轉木馬',
      xmgzldesc: '魔法般的立體光雕投影技術將貫穿整個匯演，多位迪士尼及彼思角色的投影更會現身塔樓，甚至從城堡騰飛至水幕噴泉之上。結合交織投射的激光與燈光、水柱、璀璨奪目的煙火效果、配合重新編製的迪士尼音樂與旋律，將不同角色的人生片段帶到賓客眼前，與你回憶往昔、邁步向前，活出奇妙人生。',
      xmgzl: '迪士尼星夢光影之旅',
      ylbydesc: '樂園一連串令人無法抗拒的精彩活動，讓你的迪士尼體驗更加完滿。',
      ylby: '切勿錯過的遊樂設施及娛樂表演',
      zwcxdfj: '暫無查詢到房型',
      fj: '房間',
      cr: '成人',
      et: '兒童',
      qd: '確定',
      ets: '兒童數',
      crs: '成人數',
      fjs: '房間數',
      dsndmhqf: '迪士尼的夢幻氣氛',
      ckxq: '查看詳情',
      zjdsnjdgs: '住进迪士尼的经典故事，演活属于您自己的故事。',
      lyjd: '迪士尼樂園酒店',
      hlwjd: '迪士尼好萊塢酒店',
      dyweddjjd: '獨一無二的度假酒店'
    }
  },
  user: {
    jmm: '舊密碼',
    xmm: '新密碼',
    bc: '保存',
    xm: '姓名',
    dzyj: '電子郵件',
    lxdh: '聯繫電話',
    dc: '導出',
    sjkx: '實際款項',
    fhkx: '反還款項',
    ykkx: '已扣款項',
    yxdd: '有效訂單',
    qxdd: '取消訂單',
    hjdd: '合計訂單',
    ssxt: '所屬系統',
    xdrq: '下單日期',
    syed: '使用額度',
    cpxx: '產品信息',
    ddbh: '訂單編號',
    cx: '查詢',
    js: '結束',
    ks: '開始',
    z: '至',
    rzrq: '入住日期',
    ldrq: '離店日期',
    yqx: '已取消',
    yzf: '已支付',
    wzf: '未支付',
    bx: '不限',
    ddzt: '訂單狀態',
    jd: '酒店',
    pw: '票務',
    ddlx: '訂單類型',
    lvxm: '旅客姓名',
    syyck: '剩餘預存款',
    syued: '剩餘額度',
    am: '澳門',
    xg: '香港',
    lkbxg: '留空不修改',
    mm: '密碼',
    qsrdh: '請輸入電話',
    dh: '電話',
    qsryhm: '請輸入用戶名',
    yhm: '用戶名',
    qsrxm: '請輸入姓名',
    xiugai: '修改',
    qy: '啟用',
    jy: '禁用',
    cz: '操作',
    zc: '正常',
    ty: '停用',
    zt: '狀態',
    yj: '郵件',
    dlzh: '登錄賬號',
    tj: '添加',
    qsrmm: '請輸入密碼',
    jianshu: '間數',
    ddje: '訂單金額',
    bzxx: '備註信息',
    dzf: '待支付',
    zkxx: '住客信息',
    qrh: '確認號',
    lldh: '聯絡電話',
    llyx: '聯絡郵箱',
    ykxx: '遊客信息',
    qt: '其他',
    tbz: '台胞證',
    gahxz: '港澳回鄉證',
    hz: '護照',
    sfz: '身份證',
    yx: '郵箱',
    sj: '手機',
    zj: '證件',
    csrq: '出生日期',
    xb: '性別',
    rs: '人數',
    cfrq: '出發日期',
    zcyd: '再次預定',
    fk: '付款',
    ksxz: '客人信息',
    j: '間',
    w: '晚',
    ywrq: '遊玩日期',
    krxx: '客人信息',
    cxrq: '出行日期',
    ydrq: '預定日期',
    hy: '會員',
    hzhb: '合作夥伴',
    ddlb: '訂單列表',
    qb: '全部',
    xl: '線路',
    grzl: '個人資料',
    zhjmm: '賬戶及密碼',
    zzh: '子賬號',
    zh: '賬戶',
    cwxx: '財務信息',
    edxx: '額度信息',
    zcsrmm: '再次輸入密碼',
    mmbnwk: '密碼不能為空',
    dqsxfwwdd: '當前篩選範圍內暫無訂單，',
    ljqw: '立即前往',
    ydj: '預定。',
    ss: '搜索',
    lcsrmmbyz: '兩次輸入密碼不一致'
  },
  pay: {
    PaymentList: {
      mpay: 'MPay',
      wechat: '微信支付',
      alipay: '支付寶',
      offline: '線下支付',
      quota: '額度支付',
      MPayDesc: '推薦 MPay 用戶優先選優，支付幣種MOP',
      wechatDesc: '推薦 內地 用戶優先選優，支付幣種CNY',
      alipayDesc: '推薦 內地 用戶優先選優，支付幣種CNY',
      offlineDesc: '香港 或 同行用戶可通過線下轉賬形式進行支付',
      quotaDesc: '同行額度支付'
    },
    qy: '請於',
    nzfdd: '內支付訂單',
    fkfs: '付款方式',
    ljzf: '立即支付',
    fksb: '付款失敗',
    fkcg: '付款成功',
    zfcg: '支付成功，返回首頁',
    zfsb: '支付失敗,返回產品',
    ddbh: '訂單編號',
    xszf: '線上支付',
    rz: '入住',
    ld: '離店',
    js: '間數',
    ywrq: '遊玩日期',
    sl: '數量',
    cpmc: '產品名稱',
    cxrq: '出行日期',
    bstk: '不設退款',
    ddqrhbkqxhgg: '訂單確認後不可取消或更改。若您有效期內沒有使用，將收取全額費用 。',
    hztvjbgxaqfsw: 'huayitraveltd.com將把閣下安全放在首位，本站點已通過以下機構安全驗證：'
  },
  // 星期名称翻译
  sunday: '週日',
  monday: '週一',
  tuesday: '週二',
  wednesday: '週三',
  thursday: '週四',
  friday: '週五',
  saturday: '週六'
}



// WEBPACK FOOTER //
// ./src/lang/zhHK.js